import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=282e4310"
import script from "./attachmentList.vue?vue&type=script&lang=js"
export * from "./attachmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports